/** Decode source entity escapes, never HTML. Render the result only as text.
 * Two passes handle common double encoding; unfinished escapes stay literal. */
export function decodeFoodText(value) {
    const named = { quot: '"', apos: "'", amp: '&', lt: '<', gt: '>', nbsp: '\u00a0', laquo: '«', raquo: '»', ndash: '–', mdash: '—', hellip: '…', copy: '©', reg: '®' };
    let text = value;
    for (let pass = 0; pass < 2; pass++) {
        const next = text.replace(/&(#x[0-9a-f]+|#\d+|[a-z]+);/gi, (entity, key) => {
            if (key[0] !== '#')
                return named[key] ?? entity;
            const code = key[1]?.toLowerCase() === 'x' ? Number.parseInt(key.slice(2), 16) : Number(key.slice(1));
            return code > 0 && code <= 0x10ffff && !(code >= 0xd800 && code <= 0xdfff) ? String.fromCodePoint(code) : entity;
        });
        if (next === text)
            break;
        text = next;
    }
    return text;
}
export function meaningfulFoodName(name, brands) {
    const normalize = (v) => decodeFoodText(v).toLocaleLowerCase('ru').match(/[\p{L}\p{N}]+/gu)?.join(' ') ?? '';
    const n = normalize(name);
    return Boolean(n) && !decodeFoodText(brands).split(',').some(brand => (brand.toLocaleLowerCase('ru').match(/[\p{L}\p{N}]+/gu)?.join(' ') ?? '') === n);
}
//# sourceMappingURL=food-text.js.map